module.exports = __webpack_public_path__ + "assets/img/Structure_item4.14436d67.png";